export const truncateEmail = (email?: string) => {
  if (!email) {
    return "";
  }

  let [localPart, domain] = email.split("@");
  localPart = localPart.length > 3 ? localPart.slice(0, 3) + "***" : localPart;
  return `${localPart}@${domain}`;
};
